import { render, staticRenderFns } from "./confirmed.vue?vue&type=template&id=aca7eb82"
import script from "./confirmed.vue?vue&type=script&lang=js"
export * from "./confirmed.vue?vue&type=script&lang=js"
import style0 from "./confirmed.vue?vue&type=style&index=0&id=aca7eb82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountConfirmedViewsDefault: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/confirmed/views/Default.vue').default,AccountSigninContainer: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/account/signin/Container.vue').default})
